import RelayCard from '@/components/RelayCard'
import UserAvatar from '@/components/UserAvatar'
import Username from '@/components/Username'
import { useSecondaryPage } from '@/PageManager'
import { npubEncode } from '@nostr/tools/nip19'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { THardcodedFeed } from '@/types/universe'

export default function HardcodedFeedInfo({
  item,
  className
}: {
  item: THardcodedFeed
  className?: string
}) {
  const { t } = useTranslation()
  const { push: pushSecondaryPage } = useSecondaryPage()
  const relays = item.relays ?? []
  const pubkeys = item.pubkeys ?? []

  return (
    <div className={cn('space-y-4 mb-2', className)}>
      <div className="px-4 space-y-4">
        {relays.length > 0 && (
          <div className="space-y-2">
            <div className="text-sm font-semibold text-muted-foreground">{t('Relays')}</div>
            <div className="space-y-1">
              {relays.map((url) => (
                <RelayCard key={url} url={url} className="rounded-lg hover:bg-accent/50" />
              ))}
            </div>
          </div>
        )}

        {pubkeys.length > 0 && (
          <div className="space-y-2">
            <div className="text-sm font-semibold text-muted-foreground">{t('Profiles')}</div>
            <div className="space-y-1">
              {pubkeys.map((pk) => (
                <div
                  key={pk}
                  className="flex items-center gap-3 cursor-pointer hover:text-foreground"
                  onClick={() => pushSecondaryPage('/' + npubEncode(pk))}
                >
                  <UserAvatar userId={pk} size="small" />
                  <Username userId={pk} className="text-muted-foreground text-sm truncate" />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
